import React, { useEffect } from "react";
import { useForm, useFieldArray, useWatch } from "react-hook-form";
import { TextInputFormField } from "../../../../../components/form-fields/text-input-field/text-input-form-field";
import { ProjectMaterialsStyled } from "./project-materials.styles";
import { updateProjectData } from "../../../../../services/projects-services";
import { useParams } from "react-router-dom";
import { formatNumber } from "../../../../../utils/utils";
import { Typography } from "@mui/material";

const ProjectMaterials = ({ materialsData }) => {
  const { id } = useParams();
  const { control, getValues } = useForm({
    defaultValues: {
      materials: materialsData.map((m) => ({
        description: m.description || "",
        value: m.total || "0",
        expenseType: m.expenseType || "",
        orderNumber: m.orderNumber || "",
        actuals: m.actuals || "",
      })),
    },
    mode: "all",
  });

  const { fields } = useFieldArray({ control, name: "materials" });

  // Watch the entire array so we know when any PO# flips
  const watched = useWatch({ control, name: "materials" });

  useEffect(() => {
    watched.forEach((mat, idx) => {
      const orig = materialsData[idx];
      const origPO = orig.orderNumber || "";
      const origActuals = orig.actuals || "";
      // If either PO# or Actuals changed, persist update
      if (mat.orderNumber !== origPO || mat.actuals !== origActuals) {
        const updated = materialsData.map((origMat, i) =>
          i === idx
            ? {
                ...origMat,
                orderNumber: mat.orderNumber,
                actuals: formatNumber(mat.actuals),
              }
            : origMat
        );
        updateProjectData(id, { materials: updated }).catch(console.error);
      }
    });
  }, [watched, id, materialsData]);
  return (
    <ProjectMaterialsStyled>
      <Typography variant="h6" sx={{ color: "#301D35", marginBottom: "8px" }}>
        Project Materials
      </Typography>

      {fields.map((field, index) => (
        <div key={field.id} className="material-sub-entry">
          <div className="fields">
            <TextInputFormField
              disabled
              control={control}
              name={`materials[${index}].description`}
              defaultValue={field.description}
              label={index === 0 ? "Material Description" : ""}
            />

            <TextInputFormField
              disabled
              control={control}
              name={`materials[${index}].value`}
              defaultValue={field.value}
              label={index === 0 ? "Cost ($)" : ""}
            />

            <TextInputFormField
              control={control}
              name={`materials[${index}].actuals`}
              defaultValue={field.actuals}
              label={index === 0 ? "Actuals ($)" : ""}
              className="po-field"
            />

            <TextInputFormField
              disabled
              control={control}
              name={`materials[${index}].expenseType`}
              defaultValue={field.expenseType}
              label={index === 0 ? "Expense Type" : ""}
            />

            <TextInputFormField
              control={control}
              name={`materials[${index}].orderNumber`}
              defaultValue={field.orderNumber}
              label={index === 0 ? "PO #" : ""}
              className="po-field"
            />
          </div>
        </div>
      ))}
    </ProjectMaterialsStyled>
  );
};

export default ProjectMaterials;
